import React from "react";
import "../css/mottobar.css";

export default function MottoBar() {
  return (
    <div className="motto-bar">
      <div className="motto-content">
        <span className="motto-text">
          नर सेवा, नारायण सेवा
        </span>
        <a href="/donate" className="donate-btn">
          Donate Now
        </a>
      </div>
    </div>
  );
}